import React, {useState} from 'react';
import { DatePicker, Space } from 'antd';

//const [dateSelected, setDateSelected]=useState('');

{/** *
const onChange = (date, dateString) => {

  console.log(date, dateString);
  //setDateSelected(dateString);
  getDateFromADP(dateString);
  
};

const getDateFromADPEXT=(returnDate)=>{
    //return returnDate;
    console.log("returnDate=" + returnDate);
   // return returnDate;
};
***/}
export default function AntdDatePicker ({getDateFromADP}) { 
  const onChange = (date, dateString) => {

    console.log(date, dateString);
    //setDateSelected(dateString);
    getDateFromADP(dateString);
    
  };
 
  return(
    <DatePicker
     onChange={onChange} 
     style={{
      width: '450px'
     }}
    />
)
};
//export default AntdDatePicker;